module.exports = __webpack_public_path__ + "img/dispatch_internet_error.dde628b3.svg";